import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { AriaDirective } from '../../../shared-components/directives/aria.directive';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { HealthService } from '../health.service';
import { Screening } from '../health.model';

@Component({
  selector: 'app-screening',
  templateUrl: './screening.component.html',
  styles: [],
  animations: [detailExpand]
})
export class ScreeningComponent implements OnInit, OnChanges {

  @Input() selectedStudent;
  isBusy = false;
  screening: Screening[] = [];
  screeningSelected: boolean[] = [];

  //----------Angular Material------------------------------------
  angularMatData = new TylerMatTableDataSource();
  displayedScreeningColumn = ['More', 'ScreeningType'];
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private healthService: HealthService) {

    this.angularMatData = new TylerMatTableDataSource(this.screening);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedStudent.previousValue != undefined) {
      if (changes.selectedStudent.currentValue.Id != changes.selectedStudent.previousValue.Id) {
        this.getScreenings();
      }
    }
  }

  ngOnInit() {
    this.getScreenings();
  }

  toggleMore(index: number) {
    this.screeningSelected[index] = !this.screeningSelected[index];
  }

  toggleExpanded(row: Screening) {
    this.angularMatData.toggleExpanded(row);
  }

  checkExpanded(row: Screening): boolean {
    return this.angularMatData.checkExpanded(row);
  }

  expandAll(expand: boolean) {
    this.angularMatData.expandAll(expand);
  }

  rowKeyPress(event: KeyboardEvent, row: Screening) {
    this.angularMatData.rowKeyPress(event, row);
  }

  getScreenings() {
    this.angularMatData = new TylerMatTableDataSource();
    this.isBusy = true;
    setTimeout(() => {
      this.healthService.getScreenings(this.selectedStudent.Id).subscribe(data => {
        this.screening = data;
        this.loadScreeningHistory();
      });
    }, 0);
  }

  loadScreeningHistory(): void {
    this.angularMatData = new TylerMatTableDataSource(this.screening);
    setTimeout(() => {
      this.angularMatData.sort = this.sort;
    }, 0);
    this.isBusy = false;
  }

  //------------Aria/Accessibility---------------------------
  getScreeningAriaRow(row: Screening): string {
    const colList: string[] = ['ScreeningType'];
    const dataList: string[] = [row.ScreeningType];

    return AriaDirective.concatAriaStrings(colList, dataList);
  }
}
